// extracted by mini-css-extract-plugin
module.exports = {"Select":"select_Select__3Y_Kb","inputBlock":"select_inputBlock__1IAOf","arrow":"select_arrow__1niYn","clearBtn":"select_clearBtn__1vOxH","avatar":"select_avatar__1JUvS"};